import { render, staticRenderFns } from "./BranchesView.vue?vue&type=template&id=fed5e944"
import script from "./BranchesView.vue?vue&type=script&lang=js"
export * from "./BranchesView.vue?vue&type=script&lang=js"
import style0 from "./BranchesView.vue?vue&type=style&index=0&id=fed5e944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports